import { render, staticRenderFns } from "./novel_long_info.vue?vue&type=template&id=f6e1f92a&scoped=true"
import script from "./novel_long_info.vue?vue&type=script&lang=js"
export * from "./novel_long_info.vue?vue&type=script&lang=js"
import style0 from "./novel_long_info.vue?vue&type=style&index=0&id=f6e1f92a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e1f92a",
  null
  
)

export default component.exports